<template>
<div>
<br/>
<b-row>
    <b-col cols="12">
        <app-vue-editor
            v-model="commitments"
            :editorToolbar="customToolbar"
            @input="$v.commitments.$touch()"
        ></app-vue-editor>
    </b-col>
</b-row>
</div>
</template>


<script>
import { VueEditor } from "vue2-editor";
import { required } from "vuelidate/lib/validators";
export default {
    components: {
        appVueEditor: VueEditor
    },
    props: {
        evaluationId: {
            type: [String, Number]
        }
    },
    data:() =>({
        commitments: '',
        customToolbar
    }),
    validations: {
        commitments: { required }
    },
    methods: {
        async saveCommitments(){
            if (this.$v.$invalid)
                return (
                    toastr.info("Debe diligenciar sus compromisos") &&
                    this.$v.$touch()
            );
            const {data} = await repo.post(`performance-evaluations/${this.evaluationId}/store-commitments`,{
                commitments: this.commitments,
                userId: this.user.id
            })
            if(data.status){
                this.commitments = ''
                this.$emit('success',data)
            }else{
                this.commitments = ''
                this.$emit('error',data)
            }
        }
    }
}

const customToolbar = [
    [{ font: [] }],
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike'],
    [
        { align: '' },
        { align: 'center' },
        { align: 'right' },
        { align: 'justify' },
    ],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    [{ direction: 'rtl' }],
    ['clean'],
]
</script>